import { TOOLS, type ToolId } from '../lib/tools.js';

/** A small segmented control over TOOLS. More tools slot in as entries there. */
export function ToolPicker({
  value,
  onChange,
  disabled = false,
}: {
  value: ToolId;
  onChange: (tool: ToolId) => void;
  disabled?: boolean;
}) {
  return (
    <div className="tool-picker" role="radiogroup" aria-label="Drawing tool">
      {TOOLS.map((tool) => (
        <button
          key={tool.id}
          type="button"
          role="radio"
          aria-checked={value === tool.id}
          aria-label={tool.label}
          title={tool.label}
          className={`tool-choice ${value === tool.id ? 'selected' : ''}`}
          onClick={() => onChange(tool.id)}
          disabled={disabled}
        >
          <ToolIcon id={tool.id} />
        </button>
      ))}
    </div>
  );
}

function ToolIcon({ id }: { id: ToolId }) {
  const common = {
    width: 22,
    height: 22,
    viewBox: '0 0 24 24',
    fill: 'none',
    stroke: 'currentColor',
    strokeWidth: 1.8,
    strokeLinecap: 'round' as const,
    strokeLinejoin: 'round' as const,
    'aria-hidden': true,
  };
  if (id === 'eraser') {
    return (
      <svg {...common}>
        <path d="M7 20h11" />
        <path d="M4.6 14.6 13.9 5.3a2 2 0 0 1 2.8 0l3 3a2 2 0 0 1 0 2.8L11 20H8.2l-3.6-3.6a1.3 1.3 0 0 1 0-1.8Z" />
        <path d="m9.5 10 5.5 5.5" />
      </svg>
    );
  }
  return (
    <svg {...common}>
      <path d="M4 20l1-4.5L15.8 4.7a2 2 0 0 1 2.9 0l.6.6a2 2 0 0 1 0 2.9L8.5 19 4 20Z" />
      <path d="m13.5 7 3.5 3.5" />
    </svg>
  );
}
